@if (showLockIcon) {
  &nbsp;
  <!--
    Lucide, not FontAwesome. The repo rule is that generic icons use calio-lucide-icon and
    never a FontAwesome class or an inline SVG. Fixed here first because this is a shared lib
    component rendered at 71 call sites, so one edit covers all of them - roughly 24 other
    templates still use `b-fa` directly and are a separate cleanup.
    The tooltip moves to the wrapping span because the icon component has no tooltip input.
  -->
  <span
    class="lock-icon"
    tooltipClass="question-mark"
    container="body"
    [ngbTooltip]="msg | translate"
  >
    <calio-lucide-icon name="lock" [size]="14" />
  </span>
}
